import { deslugify } from '#common/utils/slugify'

export default async function fetchWineryFilters($axios, slugs) {
  return (
    await $axios.get(`/api/catalog/wineries/?slug__in=${slugs}`)
  ).data.map(({ name, slug }) => {
    return {
      name,
      slug,
      key: slug,
      category: 'wineries',
    }
  })
}

export async function fetchMissingWineries({ $axios }, { route }) {
  const metadata = useMetadata()
  let slugs = null
  if (route.params.category === 'wineries') {
    slugs = route.params.slug
  } else if (route.query.wineries__in) {
    slugs = route.query.wineries__in
  } else if (route.query.wineries) {
    slugs = route.query.wineries
  }

  if (!slugs || !metadata.searchFilters || !metadata.searchFiltersMapping)
    return

  const unfetchedSlugs = []
  slugs.split(/,|__/).forEach((slug) => {
    const filter = metadata.searchFilterByCategoryAndKey('wineries', slug)
    if (!filter) {
      unfetchedSlugs.push(slug)
    }
  })
  if (unfetchedSlugs.length > 0) {
    const wineryFilters = []
    try {
      wineryFilters.push(
        ...(await fetchWineryFilters($axios, unfetchedSlugs.join(','))),
      )
      metadata.pushFilters(wineryFilters)
    } catch (e) {
      console.error(e)
      wineryFilters.push(
        ...unfetchedSlugs.map((slug) => {
          return {
            name: deslugify(slug),
            slug,
            key: slug,
            category: 'wineries',
          }
        }),
      )
      metadata.pushFilters(wineryFilters)
    }
  }
}
